/**
 * QuoteClientButton — "usar como fuente": toma la frase exacta del cliente
 * (un mensaje de WhatsApp) y la entrega al campo que el operador edita.
 *
 * Decisiones de diseño:
 * - Botón fantasma de tamaño ícono: aparece en cada mensaje/campo, así que
 *   debe ser visualmente silencioso hasta el hover — el hilo de chat manda.
 * - Acción delegada por completo al padre vía onQuote(): este componente no
 *   sabe qué buffer o campo recibe la cita, solo dispara la intención.
 * - title + aria-label idénticos en español para tooltip y lectores de pantalla.
 * - Estados hover / focus-visible / disabled explícitos (principio 9 del brief).
 */
import { Quote } from 'lucide-react';

const QuoteClientButton = ({ onQuote, disabled }) => (
  <button
    type="button"
    onClick={() => onQuote && onQuote()}
    disabled={disabled}
    aria-label="Usar como fuente"
    title="Usar como fuente"
    className="inline-flex items-center justify-center rounded-md p-1.5
               hover:bg-[var(--nav-active-bg)]
               focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--blue)]
               disabled:opacity-40 disabled:cursor-not-allowed"
    style={{ color: 'var(--text-tertiary)' }}
  >
    <Quote size={13} aria-hidden="true" />
  </button>
);

export default QuoteClientButton;

/*
Ejemplo de uso (sobre un mensaje del hilo de WhatsApp):
  <QuoteClientButton onQuote={() => setQuoteBuffer(mensaje.text)} />
*/
